import { ReactNode } from "react";
import { Row } from "../../Layout/utils";

export const FilterGroupRow = ({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}) => {
  return (
    <Row
      sx={{
        alignItems: "center",
        gap: 0.5,
      }}
    >
      {children}
    </Row>
  );
};
